export default "__VITE_ASSET__CwXcnlzh__"